import { ORDER_TYPE_MANUAL } from '../../constants';
import { CheckoutState } from '../../state';
import { isUserLoggedIn } from '../user';
import { getNamespaceValue } from '../utils/selector';

export const getIsNosSourceOfTruth = (state: CheckoutState) =>
    getNamespaceValue(state.order, 'isNosSourceOfTruth', false);

export const isOrderPlaced = (state: CheckoutState) =>
    getNamespaceValue(state.order, 'isPlaced', false);

export const getCurrencyFromOrder = (state: CheckoutState) =>
    getNamespaceValue(state.order, 'costs.gross.currency');

export const getOrderId = (state: CheckoutState) =>
    getNamespaceValue(state?.order, 'id');

export const getOrderPersistentId = (state: CheckoutState) => {
    const orderId = getOrderId(state);
    const isOrderPlaced = getNamespaceValue(state?.order, 'isPlaced', false);

    // Orders always have an ID. In LOS (Legacy Order Service) before the order is placed it is in a volatile state,
    // living in Redis. In this state the ID of the order is different than the ID after the order is placed.
    // We can distinguish both IDs because the volatile ID always begins with `O-` prefix.
    // In NOS (New Order Service) the Order Document always has the same ID, before it is confirmed and afterwards.
    return isOrderPlaced ? orderId : null;
};

export const getOrderRegistrationFormSurveyInfo = (state: CheckoutState) => {
    return getNamespaceValue(state, 'order.registrationForm.surveyInfo');
};

export const hasExistingOrder = (state: CheckoutState) =>
    !!getNamespaceValue(state.app, 'existingOrderId');

/**
 * @returns `true` when there is an exising order ID and it is a manual order
 */
export const isAddAttendeesOrder = (state: CheckoutState) => {
    return (
        hasExistingOrder(state) &&
        getNamespaceValue(state.order, 'augmentedInfo.orderType') ===
            ORDER_TYPE_MANUAL
    );
};

export const shouldManageUserSavedSurveyData = (state: CheckoutState) =>
    isUserLoggedIn(state) && !isAddAttendeesOrder(state);
